import { Hidden } from '@material-ui/core';
import Drawer from '@material-ui/core/Drawer/Drawer';
import Snackbar from 'components/Shared/Snackbar';
import { WithStyles } from 'decorators/withStyles';
import { ICoupon, IExitPopUp } from 'interfaces/IExitPopUp';
import { IProductNew } from 'interfaces/product';
import React, { Component } from 'react';
import { combineLatest } from 'rxjs';
import * as rxjsOperators from 'rxjs-operators';
import { analyticsG4, enFeatures } from 'services/AnalyticsG4';
import { exitPopUpService } from 'services/exitPopUpService';
import { productNewService } from 'services/productNewService';

import ExitPopUpComponent from './ExitPopUpComponent';
import SideBar from './SideBar';

interface IState {
  selectedProduct: IProductNew;
  exitPopUp: IExitPopUp;
  coupon?: ICoupon;
}

interface IProps {
  classes?: any;
}

@WithStyles(() => ({
  '@keyframes toLeft': {
    from: {
      transform: 'translate(2600px)'
    },
    to: {
      transform: 'translate(0)'
    }
  },
  drawerPaper: {
    transform: 'translate(2600px)',
    animation: 'toLeft 0.3s ease-in-out 0.5s forwards',
    fontFamily: 'Lato',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    overflowY: 'hidden',
    height: 'calc(100% - 35px)',
    width: '100%',
    '@media screen and (max-width: 960px)': {
      width: '100%'
    }
  }
}))
export default class ExitPopUpCustomizer extends Component<IProps, IState> {
  constructor(props: any) {
    super(props);
    this.state = { exitPopUp: undefined, selectedProduct: undefined };
  }

  componentDidMount() {
    productNewService
      .getSelectedProduct()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(selectedProduct => this.setState({ selectedProduct }));

    exitPopUpService
      .getExitPopUpProduct()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(exitPopUp => this.setState({ exitPopUp }));

    combineLatest([exitPopUpService.getExitPopUpProduct(), productNewService.getSelectedProduct()])
      .pipe(
        rxjsOperators.bindComponent(this),
        rxjsOperators.map(([exitPopUp, selectedProduct]) => {
          return { selectedProduct, exitPopUp: !!exitPopUp };
        }),
        rxjsOperators.distinctUntilChanged((a, b) => JSON.stringify(a) === JSON.stringify(b)),
        rxjsOperators.filter(({ exitPopUp, selectedProduct }) => !!selectedProduct && !!exitPopUp)
      )
      .subscribe(() => {
        analyticsG4.sendPageView({ feature: enFeatures.EXITPOPUP });
      });
  }

  enableExitPopUp = () => {
    const { exitPopUp } = this.state;
    this.setState({ exitPopUp: { ...exitPopUp, enabled: !exitPopUp.enabled } });
  };

  changeTitle = (event: any) => {
    const { exitPopUp } = this.state;

    this.setState({
      exitPopUp: {
        ...exitPopUp,
        timer: {
          ...exitPopUp.timer,
          theme: { ...exitPopUp.timer.theme, title: event.target.value }
        }
      }
    });
  };

  changeMsgButton = (event: any) => {
    const exitPopUp = this.state.exitPopUp;
    const { button } = exitPopUp;

    this.setState({
      exitPopUp: { ...exitPopUp, button: { ...button, theme: { ...button.theme, text: event.target.value } } }
    });
  };

  enableExitPopUpTime = () => {
    const { exitPopUp } = this.state;
    this.setState({
      exitPopUp: { ...exitPopUp, timer: { ...exitPopUp.timer, enabled: !exitPopUp.timer.enabled } }
    });
  };

  changeTime = (event: any) => {
    const { exitPopUp } = this.state;
    this.setState({
      exitPopUp: {
        ...exitPopUp,
        timer: {
          ...exitPopUp.timer,
          time: Number(event.target.value)
        }
      }
    });
  };

  enableButton = () => {
    const exitPopUp = this.state.exitPopUp;
    const { button } = exitPopUp;

    this.setState({
      exitPopUp: { ...exitPopUp, button: { ...button, enabled: !button.enabled } }
    });
  };

  onSubmit = () => {
    const { coupon, selectedProduct, exitPopUp } = this.state;
    if (
      exitPopUp.button.theme.textSize < 9 ||
      exitPopUp.button.theme.textSize > 96 ||
      Number(exitPopUp.timer.theme.titleSize) < 9 ||
      Number(exitPopUp.timer.theme.titleSize) > 96
    ) {
      Snackbar.error('Tamanho do texto inválido');
      return;
    }
    if (!exitPopUp.media.image && !exitPopUp.media.video && exitPopUp.enabled) {
      Snackbar.error('É necessário conter uma imagem ou um vídeo em seu pop up de saída');
      return;
    }

    if (!!exitPopUp.button.enabled && !exitPopUp.button.theme.text) {
      Snackbar.error('É necessário você preencher o texto do botão.');
      return;
    }

    if (!!exitPopUp.timer.enabled && !exitPopUp.timer.theme.title) {
      Snackbar.error('É necessário você preencher o título do timer.');
      return;
    }

    exitPopUpService
      .changeExitPopUp(exitPopUp)
      .pipe(
        rxjsOperators.switchMap(() => exitPopUpService.save(coupon, exitPopUp, selectedProduct)),
        rxjsOperators.loader(),
        rxjsOperators.bindComponent(this)
      )
      .subscribe(() => {
        analyticsG4.sendSuccess(enFeatures.EXITPOPUP);
        Snackbar.show('Exit pop up salvo com sucesso!');
        productNewService.setSelectedProduct({ ...selectedProduct, exitPopUp: { active: true } });
        productNewService.refreshProducts();
      });

    this.onClose();
  };

  onClose = () => {
    exitPopUpService.changeExitPopUp(null).subscribe(() => this.setState({ exitPopUp: null }));
  };

  render() {
    const { classes } = this.props;
    const { selectedProduct, exitPopUp } = this.state;

    if (!selectedProduct || !exitPopUp) {
      return null;
    }

    return (
      <Drawer
        anchor="right"
        open={!!selectedProduct}
        ModalProps={{
          classes: { root: classes.removeBackdrop },
          disableBackdropClick: true,
          onBackdropClick: this.onClose
        }}
        PaperProps={{ classes: { root: classes.drawerPaper } }}
        transitionDuration={{ enter: 300, exit: 500 }}
      >
        <Hidden smDown>
          <ExitPopUpComponent exitPopUp={exitPopUp} />
        </Hidden>
        <SideBar
          exitPopUp={exitPopUp}
          changeTime={this.changeTime}
          enableExitPopUpTime={this.enableExitPopUpTime}
          changeMsgButton={this.changeMsgButton}
          changeTitle={this.changeTitle}
          enableExitPopUp={this.enableExitPopUp}
          enableButton={this.enableButton}
          onSubmit={this.onSubmit}
          onClose={this.onClose}
        />
      </Drawer>
    );
  }
}
